import { saveAs } from "file-saver";
import { useContext } from "react";
import {AuthContext} from "../../contexts/AuthContext";
import { NavLink} from "react-router-dom";


function PurchaseOrderRow({purchaseOrder}) {
    const {token} = useContext(AuthContext);

    async function getPDF(evt) {
        evt.preventDefault()
        try {
            const response = await fetch(`${process.env.REACT_APP_endPoint}/v1/purchaseOrders/downloadPDF/${purchaseOrder.id}`, {
                method: "GET",
				credentials: "include"
			});

            if (response.status === 200) {
                const blob = await response.blob();
                saveAs(blob, purchaseOrder.pdfFileName);
            }
            else {
                console.log(response);
            }
        }
        catch (e) {
            console.error(e);
        }
    }

	return (
		<tr>
            <td><NavLink to={`/customerTasks?poNumber=${purchaseOrder.number}&poId=${purchaseOrder.id}`}>{purchaseOrder.number}</NavLink></td>
			<td>{purchaseOrder.customer.firstName}</td>
			<td>{purchaseOrder.description}</td>
			<td>{purchaseOrder.billingEntity?.name}</td>
			<td>{purchaseOrder.totalValue.toFixed(2)}</td>
			<td>{purchaseOrder.currency.name}</td>
			<td><a href="#" onClick={getPDF}>{purchaseOrder.pdfFileName}</a></td>
			<td>{purchaseOrder.valueConsumed.toFixed(2)}</td>
			<td>{purchaseOrder.valueRemaining.toFixed(2)}</td>
			<td>{purchaseOrder.comments}</td>
		</tr>
	);
}

export default PurchaseOrderRow;
